module.exports = __webpack_public_path__ + "static/media/ic_nav_02_selected.d2c45944.svg";